<template>
  <div class="kpis-overview-page">
    <TakeDowns />
  </div>
</template>

<script>
import TakeDowns from '@/components/TakeDowns/Index.vue'
export default {
  components: {
    TakeDowns
  },
  data(){
    return{
      brandid: this.$route.params.Id
    }
  },

}
</script>